import {useEffect, useState} from "react";
import {servicesList} from "../Constants/serviceType";
import {
    getPendingAppointments,
    retrieveAppointments,
    setFutureAppointments,
} from "../redux/appointmentList/appointmentList.actions";
import moment from "moment";
import PusherApptList from "../helpers/appointmentListHelper";
import {RootState, useAppDispatch} from "../redux/store";
import {useSelector} from "react-redux";


export const useUpdateUpcomingAppts = () => {
    const dispatch = useAppDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const user = useSelector((state: RootState) => state?.user);
    const todayDate = new Date();
    const date = todayDate.toJSON();

    const paramsSAMEDAY = {
        date,
        appointmentType: servicesList,
    };

    const updateAppointmentList = () => {
        const responseSame = dispatch(retrieveAppointments(paramsSAMEDAY));
        setIsLoading(true);
        return responseSame
            .then(values => {
                let requestMode = values.map(({appointment, appointmentRequestList, paidTotalAmount}) => {
                    const appList = appointmentRequestList
                        // fast fix (should be fixed in future
                        .filter(({scheduledDate}) => {
                            return moment(scheduledDate).add(3, "hour") > moment();
                        })
                        .sort((curr, prev) => {
                            return new Date(curr.scheduledDate).getTime() - new Date(prev.scheduledDate).getTime();
                        })
                        .map(({scheduledDate, id}) => ({
                            ...appointment,
                            paidTotalAmount,
                            scheduledDate: appointment?.scheduledDate || scheduledDate,
                            pending: appointment.status === "REQUEST_MADE" ? true : false,
                            id: appointment.id,
                        }));
                    return [...appList];
                });
                requestMode = requestMode.reduce((acum, curent) => {
                    acum = [...acum, ...curent];
                    return acum;
                }, []);
                const data = [...requestMode, ...values[0], ...values[1]].reduce((acum, curent) => {
                    const resAcun = acum.map(({id}) => id);
                    const {id} = curent;
                    if (!resAcun.includes(id)) {
                        acum.push(curent);
                    }
                    return acum;
                }, []).sort((curr, prev) => {
                    return new Date(curr.scheduledDate).getTime() - new Date(prev.scheduledDate).getTime();
                });
                dispatch(setFutureAppointments(data));
                setIsLoading(false);
            }).catch(console.log);
    };

    const subscriber = pusherApptList => {
        pusherApptList.bind(PusherApptList.EVENT_UPDATE, function (data) {
            updateAppointmentList();
        });
    };

    const unSubscriber = pusherApptList => {
        PusherApptList.unsubscribeChannel(user.userId);
        if (pusherApptList) {
            pusherApptList.unbind(PusherApptList.EVENT_UPDATE);
        }
    };

    useEffect(() => {
        updateAppointmentList();
        const list = PusherApptList.subscribeChannel(user.userId);
        if (list) {
            subscriber(list);
            return () => unSubscriber(list);
        }
    }, []);

    return isLoading;
};
